export class MarginStyleFormatHelper {
    static _targetTexts = {
        "component": "Componente",
        "description": "Descrição",
        "text": "Texto",
        "schedule": "Horário",
        "stopslist": "Lista das Paragens",
        "zonesbar": "Zonas",
        "durationbar": "Duração",
        "smscode": "Código SMS",
        "stopcode": "Código da Paragem",
        "stopname": "Nome da Paragem",
        "linecode": "Código da Linha",
        "linename": "Nome da Linha",
        "qrcode": "QR Code",
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/MarginStyleFormatHelper.js